import React, { useState } from 'react';
import { sendLeadEmail } from '../api/emailHandler';
import './Hero.css';

function Hero({ showForm, setShowForm }) {
  const [isLoading, setIsLoading] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    turnover: 'Not Specified'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setSubmitStatus(null);

    try {
      await sendLeadEmail(formData);
      setSubmitStatus('success');
      setTimeout(() => {
        setFormData({ name: '', email: '', phone: '', turnover: 'Not Specified' });
        setShowForm(false);
        setSubmitStatus(null);
      }, 2000);
    } catch (error) {
      console.error('Failed to send email:', error);
      setSubmitStatus('error');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="hero-section">
      <div className="hero-content">
        <h1 className="hero-title">
          Protect Payments. <span className="highlight">Assure Success.</span>
        </h1>
        <p className="hero-description">
          Protect your business from payment defaults, expand confidently to new markets, and improve cash flow with <span className="highlight-text">PayAssured Business Protection Plan</span>.
        </p>
        <div className="hero-cta">
          {!showForm ? (
            <button 
              className="primary-button"
              onClick={() => setShowForm(true)}
            >
              Contact Us
            </button>
          ) : (
            <form onSubmit={handleSubmit} className="contact-form">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  disabled={isLoading}
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  disabled={isLoading}
                />
              </div>
              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleInputChange}
                  required
                  disabled={isLoading}
                />
              </div>
              {submitStatus === 'success' && (
                <div className="form-status success">
                  Thank you! We'll contact you soon.
                </div>
              )}
              {submitStatus === 'error' && (
                <div className="form-status error">
                  Something went wrong. Please try again.
                </div>
              )}
              <div className="form-buttons">
                <button 
                  type="submit" 
                  className={`primary-button ${isLoading ? 'loading' : ''}`}
                  disabled={isLoading}
                >
                  {isLoading ? 'Sending...' : 'Submit'}
                </button>
                <button 
                  type="button" 
                  className="secondary-button"
                  onClick={() => setShowForm(false)}
                  disabled={isLoading}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

export default Hero; 